// Wave UX-2.1 Item 4 (2026-05-23) — 마감 임박 알림 helper.
// 클라이언트 사이드 분류: D-1h / D-10m / >1h / ended.
// 백엔드 변경 0 — /me/favorites + /me/bids 응답만 활용.

var BUCKET_1H_MS = 60 * 60 * 1000;
var BUCKET_10M_MS = 10 * 60 * 1000;

// "1h" / "10m" / "later" / "ended" 분류
export function classifyEndsAt(endsAtIso, nowMs) {
  if (!endsAtIso) return 'later';
  var end = new Date(endsAtIso).getTime();
  if (isNaN(end)) return 'later';
  var diff = end - (nowMs != null ? nowMs : Date.now());
  if (diff <= 0) return 'ended';
  if (diff <= BUCKET_10M_MS) return '10m';
  if (diff <= BUCKET_1H_MS) return '1h';
  return 'later';
}

// /me/favorites + /me/bids 결과 → 통합 ending-soon 목록.
// 중복 제거 (같은 auctionId 가 즐겨찾기 + 입찰 둘 다인 경우 source='both').
//
// 반환 형식:
//   [
//     {
//       id: 123,
//       endsAt: '2026-05-23T15:00:00',
//       bucket: '10m' | '1h',
//       source: 'favorite' | 'bid' | 'both',
//       title: '2020 X5',
//       carNumber: '99가1234',
//     },
//     ...
//   ]
export function buildEndingSoonList(favorites, bids, nowMs) {
  var now = nowMs != null ? nowMs : Date.now();
  var map = {};
  function add(a, source) {
    if (!a || !a.id) return;
    var bucket = classifyEndsAt(a.endsAt, now);
    if (bucket !== '1h' && bucket !== '10m') return;
    var existing = map[a.id];
    if (existing) {
      // 같은 차량 — source 병합
      if (existing.source !== source) existing.source = 'both';
      return;
    }
    var car = a.car || {};
    map[a.id] = {
      id: a.id,
      endsAt: a.endsAt,
      bucket: bucket,
      source: source,
      title: car.model || a.title || '',
      carNumber: car.number || '',
    };
  }
  (favorites || []).forEach(function(a){ add(a, 'favorite'); });
  (bids || []).forEach(function(a){
    if (!a) return;
    var bidStatus = a.myBid && a.myBid.status;
    if (bidStatus !== 'active') return;     // active 입찰만 알림
    add(a, 'bid');
  });
  var list = Object.keys(map).map(function(k){ return map[k]; });
  // 10m 우선, 그 다음 endsAt 오름차순
  list.sort(function(a, b) {
    if (a.bucket !== b.bucket) return a.bucket === '10m' ? -1 : 1;
    return new Date(a.endsAt).getTime() - new Date(b.endsAt).getTime();
  });
  return list;
}

// 남은 시간 라벨 포맷 (locale-aware via t)
export function formatRemaining(endsAtIso, t, nowMs) {
  if (!endsAtIso) return '';
  var end = new Date(endsAtIso).getTime();
  if (isNaN(end)) return '';
  var diff = end - (nowMs != null ? nowMs : Date.now());
  if (diff <= 0) return t ? t('cardEnded') : '마감';
  var h = Math.floor(diff / (60 * 60 * 1000));
  var m = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
  if (h > 0) return t ? t('notifEndingHm', { h: h, m: m }) : (h + '시간 ' + m + '분 남음');
  return t ? t('notifEndingM', { m: m }) : (m + '분 남음');
}
